import Helmet from "react-helmet"
import React from "react"
import Disclosure from "@tightrope/disclaimers";
import ExtendedHomepage from "src/components/extendedHomepage"
import HomepageLayout from "src/layouts/homepage"
import RawFooter from "@tightrope/footerlinks/rawfooter.js"


const homepageData = import("./homepage.json");

export default function HomePage() {
  const disclosure = <Disclosure language='mbc-windows'></Disclosure>;
  return(
    <HomepageLayout>
      <Helmet>
      <style type="text/css">{`
#disclaimers-module--disclaimers p {
  text-align: center;
  color: #777;
  font-size: 13px;
  width: 345px;
  line-height: 150%;
  margin: 0 auto 16px;
}

#disclaimers-module--disclaimers p a {
  color: #0080e6;
}
  .rawfooter-module--rawfooter {
    position:relative !important
    }
        footer {
          position: relative;
          width: 100%;
          padding: 0;
          margin:0;
          z-index: 1;
          background:#17212e;
          border:none;
        }
        footer ul {
          display: flex;
          justify-content: center;
          align-items: center;
          flex-wrap:wrap;
          color: #777;
          font-size: 12px;
          padding: 10px 0;
          list-style:none;
        }
        footer ul li {
          margin: 0;
        }
        footer ul li a {
          text-decoration: none;
          color: #777;
        }
        footer ul li:after {
          content: '|';
          padding: 0 4px;
        }
        footer ul li:last-child:after {
          content: none;
          padding: 0;
        }

        @media screen and (max-width: 576px) {

        .extendedhomepage-module--bannerLeft #disclaimers-module--disclaimers p, .extendedhomepage-module--middle #disclaimers-module--disclaimers p, .extendedhomepage-module--bottom #disclaimers-module--disclaimers p {
          width: 90%;
        }
      }

                

        `}</style>
      <title>Manuals by Clear</title></Helmet>
      <ExtendedHomepage data={homepageData}>
      <div className="disc">{disclosure}</div>
      </ExtendedHomepage>
      <RawFooter></RawFooter>
    </HomepageLayout>
  )
}
